import { render } from "./ScoreCard.vue?vue&type=template&id=76d6b087&scoped=true"
import script from "./ScoreCard.vue?vue&type=script&lang=js"
export * from "./ScoreCard.vue?vue&type=script&lang=js"

import "./ScoreCard.vue?vue&type=style&index=0&id=76d6b087&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76d6b087"]])

export default __exports__